/* unplugin-vue-components disabled */import { render } from "./dropdown-calendar.vue?vue&type=template&id=544f9186"
import script from "./dropdown-calendar.vue?vue&type=script&lang=js"
export * from "./dropdown-calendar.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/filters/dropdown-calendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "544f9186"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('544f9186', __exports__)) {
    api.reload('544f9186', __exports__)
  }
  
  module.hot.accept("./dropdown-calendar.vue?vue&type=template&id=544f9186", () => {
    api.rerender('544f9186', render)
  })

}


export default __exports__